<template>
  <div class="volume-of-activity activity">
    <bimTextH5 bold class="activity__title text-center">Объем деятельности за все время</bimTextH5>
    <bimRow justify="center">
      <bimCol 
        cols="12" 
        sm="4"
        v-for="{ name, count } in data"
        :key="name"
        class="text-center mb-9 mb-md-0 activity__one-volume"
      >
        <bimTextH3 bold>{{ count }}</bimTextH3>
        <bimTextAccent class="mt-6">{{ name }}</bimTextAccent>
      </bimCol>
    </bimRow>
  </div>
</template>

<script>
import bimRow from "@bimlib/components/bimRow"
import bimCol from "@bimlib/components/bimCol"

import bimTextAccent from "@bimlib/components/bimTextAccent"
import bimTextH3 from "@bimlib/components/bimTextH3"
import bimTextH5 from "@bimlib/components/bimTextH5"

export default {
  name: "volume-of-activity",
  components: {
    bimRow,
    bimCol,

    bimTextAccent,
    bimTextH5,
    bimTextH3,
  },
  props: {
    data: Array,
  },
}

</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";
.volume-of-activity {
  padding: 92px 0;
  @media screen and (max-width: 576px) {
    padding: 42px 0;
  }
}

.activity__title {
  margin-bottom: 47px;
  ::v-deep .text__inner {
    @media screen and (max-width: 576px) {
      font-size: 24px !important;
    }
  }
}

.activity__one-volume {
  @media screen and (max-width: 576px) {
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}

.text-center {
  text-align: center;
}
</style>
